import { useGameFormState } from "../shared/useGameFormState";
import CreateGameWizard from "./CreateGameWizard";

const CreateGame = () => {
  const state = useGameFormState({ isEdit: false });

  return <CreateGameWizard {...state} />;
};

export default CreateGame;
